import React, { Component } from 'react';
import base from '../../rebase';
import { FIREBASEREF_UPLOADS } from '../../globals';
import { Segment, Menu } from 'semantic-ui-react';
import FileTable from './FileTable/FileTable';

class FileTableContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            uploads: null,
            showOnlyUserUploads: true
        };

        this.baseRef = null;
        this.sortfunction = this.sortfunction.bind(this);
        this.handleItemClick = (e, { name }) => this.setState({ showOnlyUserUploads: name === "showonlyuser" });
        this.bindUploadsToState = this.bindUploadsToState.bind(this);
    }

    componentDidMount() {
        this.bindUploadsToState(this.props.authUser.tour_operator);
    }

    bindUploadsToState(topId) {
        this.setState({ loading: true });
        if (this.baseRef) base.removeBinding(this.baseRef);
        this.baseRef = base.bindToState(FIREBASEREF_UPLOADS, {
            context: this,
            state: 'uploads',
            asArray: true,
            queries: {
                orderByChild: 'tour_operator',
                equalTo: topId
            },
            then() {
                this.setState({ loading: false });
            }
        })
    }

    componentWillReceiveProps(newprops) {
        if (newprops.authUser.tour_operator === this.props.authUser.tour_operator) return;
        this.bindUploadsToState(newprops.authUser.tour_operator);
    }

    sortfunction(a, b) {
        if (a.timestamp < b.timestamp) return 1;
        if (a.timestamp > b.timestamp) return -1;
        return 0;
    }

    render() {
        if (this.state.loading) return null;
        if (!this.state.uploads) return null;
        if (this.state.uploads.length === 0) return null;

        var data = this.state.uploads.filter(upload => {
            if (!("type" in upload)) return false;
            if (upload.type.toUpperCase() !== this.props.fileType) return false;
            return true;
        })

        if (this.state.showOnlyUserUploads) {
            data = data.filter(upload => upload.uid === this.props.authUser.uid);
        }

        data = data.sort(this.sortfunction)

        return (
            <Segment basic loading={this.state.loading} >
                <Menu text>
                    <Menu.Item header>Show uploads by:</Menu.Item>
                    <Menu.Item name="showonlyuser" active={this.state.showOnlyUserUploads} onClick={this.handleItemClick}>Me</Menu.Item>
                    <Menu.Item name="showtouroperator" active={!this.state.showOnlyUserUploads} onClick={this.handleItemClick}>Touroperator</Menu.Item>
                </Menu>

                <FileTable data={data} onlyUser={this.state.showOnlyUserUploads} fileType={this.props.fileType} />
            </Segment>
        );
    }
}

export default FileTableContainer;


// WEBPACK FOOTER //
// ./src/pages/Home/FileTableContainer.js